// Note: The first file of a module here, must also register the module

import "./canvasser-tracking-list.component";
import "./canvasser-tracking-map.component";
import "./canvasser-tracking.component";
import "./canvasser-tracking-info.component";
import "./widget/canvasser-tracking-widget.component";
import "./widget/canvasser-tracking-widget-users.component";
import "./widget/leader/leader-canvasser-tracking-widget.component";
